import { render } from "./index.vue?vue&type=template&id=7818837a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=7818837a&lang=less&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7818837a"]])

export default __exports__